import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Founder.css";
import "../styles/publication.css";
import "../styles/interview.css";
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { faDownLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "./Loader.jsx";

const Founder = () => {
  const [activeCrumb, setActiveCrumb] = useState(1);
  const [activePdf, setActivePdf] = useState(
    "https://makalukkaga.mpeoplesnet.com/books/jeeva-mulakkam.pdf"
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [bookss, setBooks] = useState([]);
  const [images, setImages] = useState([]);
  const [katuraiimages, setKatturaigal] = useState([]);
  const [velinaduimages, setVelinaduimages] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const overlayRef = useRef(null);

  // Optimized handlers
  const zoomIn = (e) => {
    e.stopPropagation();
    const newZoom = Math.min(zoomLevel + 0.25, 3);
    setZoomLevel(newZoom);
  };

  const zoomOut = (e) => {
    e.stopPropagation();
    setZoomLevel(Math.max(zoomLevel - 0.25, 1));
  };

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const handleBookClick = (pdfLink) => {
    setActivePdf(pdfLink);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/founder.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        setBooks(data.books || []);
        setImages(data.images || []);
        setKatturaigal(data.katuraiimages || []);
        setVelinaduimages(data.velinaduimages || []);
        setMeetings(data.meetings || []);
        setPhotos(data.photos || []);
        setAwards(data.awards || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedImage) {
      overlayRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedImage]);

  const handleClick = (crumb) => {
    setIsTransitioning(true);
    setActiveCrumb(crumb.id);
    // Small delay to allow the transition to complete
    setTimeout(() => setIsTransitioning(false), 300);
  };

  const ImageGallery = ({ images }) => (
    <div className="gallery-container">
      <div className="image-grid1">
        {images.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img
              src={img}
              alt={`Gallery item ${index + 1}`}
              loading="lazy"
              decoding="async"
            />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div
          className="fullscreen-overlay"
          onClick={closeImage}
          ref={overlayRef}
        >
          <div
            className="fullscreen-image-container"
            onClick={(e) => e.stopPropagation()}
            style={{ overflow: zoomLevel > 1 ? "scroll" : "hidden" }}
          >
            <img
              src={selectedImage}
              alt="Full screen"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "top left",
                width: "100%",
                height: "auto"
              }}
            />
          </div>
          <button className="close-button" onClick={closeImage}>
            ×
          </button>
          <div className="zoom-controls">
            <button className="zoom-button" onClick={zoomIn}>
              +
            </button>
            <button className="zoom-button" onClick={zoomOut}>
              -
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const PdfViewer = () => (
    <section className="publication-container">
      <h1 className="publication-title">படைப்புகள்</h1>
      <div className="publication-layout">
        <div className="book-list">
          {bookss.map((book) => (
            <div
              className={`book-item ${
                activePdf === book.pdfLink ? "active" : ""
              }`}
              key={book.id}
              onClick={() => handleBookClick(book.pdfLink)}
            >
              <div className="flip-book-container">
                <div className="flip-book">
                  <div className="page front">
                    <img
                      src={book.image}
                      alt={book.title}
                      className="book-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="page middle">
                    <div className="page-content">
                      <p>{book.flipContent[0]}</p>
                    </div>
                  </div>
                  <div className="page back">
                    <div className="page-content">
                      <p>{book.flipContent[1]}</p>
                    </div>
                  </div>
                  <div className="page last">
                    <div className="page-content">
                      <p>{book.flipContent[2]}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="book-info">
                <h3 className="book-title">{book.title}</h3>
                <p className="book-description">{book.description}</p>
                <p className="readpub">
                  <a
                    href={book.pdfLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="readpub1"
                  >
                    Read more
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="pdf-viewer1">
          {activePdf ? (
            <iframe
              src={activePdf}
              title="PDF Viewer"
              className="pdf-iframe"
              width="100%"
              height="100%"
              loading="lazy"
            ></iframe>
          ) : (
            <div className="pdf-placeholder">
              <p>Click on a book to view its PDF</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );

  const AwardsTable = () => (
    <div id="tab3" className="tab-content">
      <h1>விருதுகள்</h1>
      <table>
        <thead>
          <tr>
            <th>Title of Award</th>
            <th>Year</th>
            <th>View PDF</th>
          </tr>
        </thead>
        <tbody>
          {awards.map((award, index) => (
            <tr key={index}>
              <td>{award.title}</td>
              <td>{award.year}</td>
              <td>
                <a
                  href={award.pdf}
                  className="btn-view"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
                <a href={award.pdf} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon
                    icon={faDownLong}
                    size="2x"
                    className="iconss"
                  />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const LifeInfo = () => (
    <div id="tab1" className="tab-content">
      <h1>வாழ்க்கைக் குறிப்பு</h1>
      <p className="tab-content1">
        <span className="heading">இளைஞர் இயக்கங்களின் பிம்பம்:- &nbsp;</span>
        <ul className="spacing">
          <li>
            தனது 10ஆவது வயதில்
            <span className="heading1"> 'மாணவர் முன்னேற்ற சங்கம்'</span> என்ற
            அமைப்பைத் தொடங்கினார்.
          </li>
          <li>
            பின்னர்
            <span className="heading1"> 'பாரதி இளைஞர் மன்றம்'</span> என்ற இளைஞர்
            அமைப்பைத் தோற்றுவித்து தொடர்ந்து சிறப்புடன் நடத்தி வந்தார்.
          </li>
          <li>இந்த அமைப்பு வெள்ளி விழாக் கண்ட பெருமை கொண்டது.</li>
          <li>
            அத்தோடு{" "}
            <span className="heading1">
              'பகத்சிங் இளைஞர் மன்றம்', 'இளைஞர் எழுச்சி இயக்கம்'
            </span>{" "}
            ஆகிய அமைப்புக்களைத் தோற்றுவித்து நடத்திவந்தார்.
          </li>
          <li>
            ஒரு கட்டத்தில் இத்தனை அமைப்புக்களையும் ஒன்றிணைத்து
            <span className="heading1">'மக்கள் சிந்தனைப் பேரவை'</span> என்ற
            கட்சி சார்பற்ற பொது நல அமைப்பினை கடந்த இருபது ஆண்டுகளுக்கு முன்பு
            நிறுவினார்.
          </li>
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">மாநிலம் தழுவிய சமூக இயக்கம்:-&nbsp;</span>
        <ul className="spacing">
          <li>
            <span className="heading1">'மக்கள் சிந்தனைப் பேரவை'</span> - என்ற
            இவர் உருவாக்கிய பொது நல அமைப்பு ஈரோட்டைத் தலைமையிடமாக கொண்டு மாநிலந்
            தழுவிய முறையில் மிகச் சிறப்பாகச் செயல்பட்டு வருகிறது.
          </li>
          <li>
            சமூகவியல் லட்சியங்களை அடிப்படையாகக் கொண்ட இவ்வியக்கம் மாணவர்கள்,
            இளைஞர்கள், ஆசிரியர்கள் மற்றும் பொதுமக்கள் மத்தியில் எழுச்சியையும்
            விழிப்புணர்வையும் ஏற்படுத்தி வருகிறது.
          </li>
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">பொது அமைப்புகளில் பங்கு:-&nbsp;</span>
        <ul className="spacing">
          ஐம்பதாண்டு காலப் பாரம்பரியம்மிக்க 'ஈரோடு தமிழ் இலக்கியப்
          பேரவை'(சாகித்ய அகாடமியுடன் இணைக்கப்பட்டது)யின் செயலாளர், ஈரோடு மாவட்ட
          ரயில் பயணிகள் நலச் சங்கத் தலைவர் உள்ளிட்ட வேறு பல பொது அமைப்புகளிலும்
          முக்கியப் பொறுப்புகள் வகித்துச் செயல்பட்டு வருகிறார்.
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">
          சமூக விழிப்புணர்வு சொற்பொழிவுகள்:-&nbsp;
        </span>
        <ul className="spacing">
          கலை, இலக்கியம், மொழி,வரலாறு, பொருளாதாரம், அரசியல், அறிவியல்,
          சமூகவியல், தன்னம்பிக்கை, நாட்டுப்பற்று போன்ற சமூக முன்னேற்றத்திற்கும்
          மாற்றத்திற்குமான தலைப்புக்களில் மாநிலத்தின பல்வேறு பகுதிகளிலும் வேறு
          மாநிலங்களிலும் கடந்த 40 ஆண்டுகளாக சொற்பொழிவுகளை தொடர்ந்து
          நிகழ்த்தியுள்ளார்.
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">
          <span className="heading1">ஜீவா முழக்கம்</span> மலர் தொகுப்பு:-&nbsp;
        </span>
        <ul className="spacing">
          <li>
            <span className="heading1">'ஜீவா முழக்கம்'</span> - வார இதழின்
            சார்பில் சுதந்திரப் பொன் விழா மலர் ஒன்றினைத் தொகுக்கும் முழுப்
            பொறுப்பும் இவரிடத்தில் ஒப்படைக்கப்பட்டது.
          </li>
          <li>
            இவர் வட மாநிலங்களுக்கெல்லாம் நேரடியாகச் சென்று பல பயனுள்ள புதிய
            விபரங்களைத் திரட்டித் தொகுத்தார்.
          </li>
          <li>
            அம் மலர் தமிழகத்தில் வெளியான விடுதலைப் பொன் விழா மலர்களிலேயே மிகச்
            சிறந்த மலராகப் பெரிதும் பாராட்டப்பட்டது.
          </li>
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">பிரசித்தி பெற்ற நூல்கள்:-&nbsp;</span>
        <ul className="spacing">
          <li>
            <span className="heading">
              'தேச விடுதலையும் தியாகச் சுடர்களும்'
            </span>{" "}
            என்ற இவரது தொகுப்புநூல் பிரசித்தி பெற்றதாகும்.
          </li>{" "}
          <li>
            அத்தோடு
            <span className="heading">'வரலாற்றுப் பாதையில்...'</span> என்ற
            இரண்டு பாகங்களைக் கொண்ட இவர் எழுதிய நூல் 2007ஆம் ஆண்டு வெளியான தமிழ்
            நூல்களிலேயே சிறந்த நூல் என சென்னை இலக்கியச் சிந்தனை அமைப்பினரால்
            தேர்வு செய்யப்பட்டு அந்த ஆண்டிற்கான
            <span className="heading">'இலக்கியச் சிந்தனை'ப்</span> பரிசும்
            இந்நூலுக்கு வழங்கப்பட்டது.
          </li>
          <li>
            இவரது வானொலி உரைகள்{" "}
            <span className="heading">'மெய் வருத்தக் கூலிதரும்'</span> என்ற
            தலைப்பில் நூலாக வெளிவந்துள்ளது.
          </li>
        </ul>
      </p>
      <p className="tab-content1">
        <span className="heading">பல்கலைக் கழகங்களிலும் கல்லூரி:-&nbsp;</span>
        <ul className="spacing">
          பள்ளிகளிலும் மாணவர்களிடையே இடையறாது சொற்பொழிவாற்றி வரும் இவர் தனது
          வித்தியாசமான உரைவீச்சு மூலமாகவும் மக்கள் சிந்தனைப் பேரவையின் இதர
          மாணவர் நலன் சார்ந்த செயல்திட்டங்கள் மூலமாகவும் மாணவர்கள் மத்தியில் ஒரு
          ஆரோக்கியமான தாக்கத்தை உருவாக்கியுள்ளார்.
        </ul>
      </p>
    </div>
  );

  const renderTabContent = () => {
    if (isTransitioning) {
      return <Loader />;
    }

    switch (activeCrumb) {
      case 1:
        return <LifeInfo />;
      case 2:
        return <PdfViewer />;
      case 3:
        return <ImageGallery images={images} />;
      case 4:
        return <ImageGallery images={katuraiimages} />;
      case 5:
        return <ImageGallery images={velinaduimages} />;
      case 6:
        return <ImageGallery images={meetings} />;
      case 7:
        return <AwardsTable />;
      case 8:
        return <ImageGallery images={photos} />;
      default:
        return <LifeInfo />;
    }
  };

  const breadcrumbs = [
    { id: 1, label: "வாழ்க்கை குறிப்பு", path: "/" },
    { id: 2, label: "படைப்புகள்", path: "/படைப்புகள்" },
    {
      id: 3,
      label: "செய்தித்தாளில் வெளிவந்த பேட்டிகள்",
      path: "/செய்தித்தாளில் வெளிவந்த பேட்டிகள்"
    },
    { id: 4, label: "கட்டுரைகள்", path: "/கட்டுரைகள்" },
    { id: 5, label: "வெளிநாட்டுப் பயணங்கள்", path: "/வெளிநாட்டுப் பயணங்கள்" },
    { id: 6, label: "சந்திப்புகள்", path: "/சந்திப்புகள்" },
    { id: 7, label: "விருதுகள்", path: "/விருதுகள்" },
    { id: 8, label: "புகைப்படங்கள்", path: "/புகைப்படங்கள்" }
  ];

  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;

  return (
    <div className="founder-main">
      <Box className="breadcrumbs-container">
        <Breadcrumbs aria-label="breadcrumb" separator="||" maxItems={10}>
          {breadcrumbs.map((crumb) => (
            <Link
              key={crumb.id}
              className={`breadcrumb-link ${
                activeCrumb === crumb.id ? "active" : ""
              }`}
              underline="hover"
              color="inherit"
              href={crumb.path}
              onClick={(e) => {
                e.preventDefault();
                handleClick(crumb);
              }}
            >
              {crumb.label}
            </Link>
          ))}
        </Breadcrumbs>
      </Box>

      <Paper elevation={3} className="content-display">
        {renderTabContent()}
      </Paper>
    </div>
  );
};

export default Founder;
